import { render, staticRenderFns } from "./sp-upload.vue?vue&type=template&id=1ec9dd96&scoped=true"
import script from "./sp-upload.vue?vue&type=script&lang=js"
export * from "./sp-upload.vue?vue&type=script&lang=js"
import style0 from "./sp-upload.vue?vue&type=style&index=0&id=1ec9dd96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec9dd96",
  null
  
)

export default component.exports